import customDot from "./dot";
import pet from "./petInfo";
import village from "./village";
import { ls } from "@js/utils";
import { mapState } from "vuex";

const langObj = {
  0: "Afrikaans",
  1: "اَلْعَرَبِيَّةُ",
  2: "Euskara",
  3: "български",
  4: "беларуская мова",
  5: "Català",
  6: "中文",
  7: "Čeština",
  8: "Dansk",
  9: "Nederlands",
  10: "English",
  11: "Eesti keel",
  12: "Føroyskt",
  13: "Suomi",
  14: "Français",
  15: "Deutsch",
  16: "Ελληνικά",
  17: "עברית",
  18: "Magyar",
  19: "íslenska",
  20: "Bahasa Indonesia",
  21: "Italiano",
  22: "日本語",
  23: "한국어",
  24: "Latviešu valoda",
  25: "Lietuvių kalba",
  26: "Norsk",
  27: "Polski",
  28: "Português",
  29: "Română",
  30: "Русский",
  31: "Српскохрватски језик",
  32: "Slovenčina",
  33: "Slovenščina",
  34: "Español",
  35: "Svenska",
  36: "ภาษาไทย",
  37: "Türkçe",
  38: "Українська мова",
  39: "Tiếng Việt",
  40: "简体中文",
  41: "繁體中文",
  42: "Unknown",
};

export default {
  data() {
    return {
      langObj,
      maxUserLevel: 16, // 用户最大等级
      maxPetLevel: 30, // 怪兽最大等级
    };
  },
  computed: {
    ...mapState({
      langTexts: "langTexts",
    }),
  },
  updated() {
    if (this.$store && this.$store.state.dots && this.$dotFn) {
      this.$dotFn(this.$store.state.dots);
    }
  },
  mixins: [pet, village],
  filters: {
    // isRound 是否四舍五入 默认 是 （否则向下取整）
    formateNum(num, isRound = true) {
      num = isRound ? Math.round(num) : Math.ceil(num);
      if (num >= 10000000) {
        num = Math.ceil(num / 1000000) + "M";
      } else if (num >= 100000) {
        num = Math.ceil(num / 1000) + "K";
      }
      if (Number.isNaN(num)) {
        return 0;
      }
      return num;
    },
    thousandBitSeparator(num) {
      if (~~num > 0) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return 0;
    },
    language(id) {
      if (id) {
        return langObj[id];
      }
      return langObj[10];
    },
    name(val) {
      // return val && val.substring(0, 10);
      return val;
    },
    transformLang(val) {
      return langObj[val];
    },
    FormateDownTime(val, simplify = true) {
      // val为毫秒
      let secondNum = 1000,
        minNum = 60 * secondNum,
        hourNum = 60 * minNum,
        dayNum = 24 * hourNum;
      let day = Math.floor(val / dayNum);
      val = val % dayNum;
      let hour = Math.floor(val / hourNum) + "";
      val = val % hourNum;
      let min = Math.floor(val / minNum) + "";
      val = val % minNum;
      let second = Math.floor(val / secondNum) + "";
      if (simplify) {
        if (day) {
          return `${day} ${day > 1 ? "Days" : "Day"}`;
        } else {
          return `${hour.padStart(2, "0")}:${min.padStart(
            2,
            "0"
          )}:${second.padStart(2, "0")}`;
        }
      } else {
        if (day) {
          return `${day} ${day > 1 ? "Days" : "Day"} ${hour.padStart(
            2,
            "0"
          )}:${min.padStart(2, "0")}:${second.padStart(2, "0")}`;
        }
      }
    },
  },
  methods: {
    // 更具key获取文本
    T() {
      let str = this.langTexts[arguments[0]] || arguments[0];
      for (let i = 1; i < arguments.length; i++) {
        let re = new RegExp("\\{" + (i - 1) + "\\}", "gm");
        str = str.replace(re, arguments[i]);
      }
      return str;
    },
    changeLang(lang) {
      // 切换语言
      let path =
        (!location.pathname ? "" : location.pathname) +
        location.search +
        location.hash;
      ls.set("lang", lang);
      path = path.replace(
        /\/(en|ar|th|vi|pl|kr|it|id|tr|ru|pt|es|fr|de|cn|zh|jp)\//,
        `/${lang}/`
      );
      console.log(path);
      location.replace(path);
    },
    findVueComponent(name, target = this.$root) {
      let _this = this;
      if ("name" in target.$options) {
        if (target.$options.name == name) {
          return target;
        } else {
          return find();
        }
      } else {
        return find();
      }
      function find() {
        if (target.$children.length == 0) {
          return false;
        }
        let map = target.$children.map((element) => {
          return _this.findVueComponent(name, element);
        });
        map = map.filter((_) => _);
        return map[0];
      }
    },
    customDot,
    jumpTo(url) {
      if (process.env.VUE_APP_MODE == "prv") {
        url = url.replace(/(\/\/)/, `$1prv`);
      }
      url = "gtarcade-weblogin://page?href=" + url;
      new WebViewChannelPromise().appPageSchemeUrl(url).catch((e) => {
        // 失败回调
        this.$toast("请手动前往gtarcade app");
      });
    },
  },
};
